import { useCallback, useMemo, useState } from "react"

import { useImageCollectionDispatchContext } from "@l2r-front/l2r-images"
import { useNetworksDispatchContext } from "@l2r-front/l2r-networks"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { PARAM_KEY_SPEEDINGS_ACTIVE_LAYER, PARAM_KEY_SPEEDINGS_YEAR, SPEEDINGS_DEFAULT_ACTIVE_LAYER } from "../../constants/urlParams"
import { useSpeedingsGrades } from "../../hooks/queries/useSpeedingsGrades"

import { initialState, SpeedingsDispatchContext, SpeedingsStateContext } from "./SpeedingsContext.context"

export const SpeedingsContextProvider = (props) => {
    const { children } = props
    const [speedingsState, setSpeedingsState] = useState(initialState)
    const { getParam, setParam } = useUrlParams()
    const { data } = useSpeedingsGrades({ group_by: "year" })

    const { setImageCollectionCurrentYear } = useImageCollectionDispatchContext()
    const { setSelectedLinearLocations } = useNetworksDispatchContext()

    const currentYear = parseInt(getParam(PARAM_KEY_SPEEDINGS_YEAR)) || data?.filter(item => item.year <= new Date().getFullYear())?.at(-1)?.year || null
    const currentActiveLayer = getParam(PARAM_KEY_SPEEDINGS_ACTIVE_LAYER) || SPEEDINGS_DEFAULT_ACTIVE_LAYER
    const setCurrentYear = useCallback((yearlyStatus) => {
        setParam(PARAM_KEY_SPEEDINGS_YEAR, yearlyStatus?.uuid)
        setImageCollectionCurrentYear(yearlyStatus?.year)
    }, [setImageCollectionCurrentYear, setParam])

    const setCurrentActiveLayer = useCallback((layer) => {
        setParam(PARAM_KEY_SPEEDINGS_ACTIVE_LAYER, layer)
    }, [setParam])

    const setSelectedSegment = useCallback((segment = {}) => {
        const segmentUuid = segment?.properties?.uuid || segment?.uuid || null
        setSpeedingsState(value => ({
            ...value,
            selectedSegmentUuid: segmentUuid,
        }))
        setSelectedLinearLocations(segment)
    }, [setSelectedLinearLocations])

    const stateValue = useMemo(() => {
        return {
            currentActiveLayer,
            currentYear,
            selectedSegmentUuid: speedingsState.selectedSegmentUuid,
        }
    }, [
        currentActiveLayer,
        currentYear,
        speedingsState.selectedSegmentUuid])

    const dispatchValue = useMemo(() => {
        return {
            setCurrentActiveLayer,
            setCurrentYear,
            setSelectedSegment: setSelectedSegment,
        }
    }, [setCurrentActiveLayer,
        setCurrentYear,
        setSelectedSegment])

    return (
        <SpeedingsStateContext.Provider value={stateValue}>
            <SpeedingsDispatchContext.Provider value={dispatchValue}>
                {children}
            </SpeedingsDispatchContext.Provider>
        </SpeedingsStateContext.Provider>
    )
}

SpeedingsContextProvider.propTypes = {
    children: PropTypes.node,
}